import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var WifiIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("path", {
                            d: "M16 15.3a1 1 0 11-1.2 1.6c-1.647-1.236-3.97-1.236-5.719.014a1 1 0 11-1.162-1.628c2.45-1.75 5.728-1.75 8.081.014zm3.738-3.47a1 1 0 01-1.276 1.54 10.02 10.02 0 00-12.824 0 1 1 0 01-1.276-1.54 12.02 12.02 0 0115.376 0zm3.518-3.585a1 1 0 11-1.312 1.51c-5.723-4.972-14.26-4.972-19.882-.006A1 1 0 11.738 8.251c6.377-5.634 16.04-5.634 22.518-.006zM12 22.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3z"
                        }),
                        _jsxs("g", {
                            fillRule: "evenodd",
                            children: [
                                _jsx("use", {}),
                                _jsx("use", {
                                    fillRule: "nonzero"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
WifiIcon.isCarinaIcon = true;
export default WifiIcon;
